import React from 'react'
import ShipStabilization from './ShipStabilization'
import { FaShip } from "react-icons/fa6";

const Inclino = ({ dataSource }) => {

    const [dataINC] = dataSource.filter((item) =>
        item.DisplayNo === 7
    );


    return (
        <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-white/20 p-6">
            <div className="flex items-center space-x-3 mb-4">
                <div className="w-8 h-8 bg-purple-500/20 rounded-lg flex items-center justify-center">
                    <FaShip className="w-4 h-4 text-purple-600" />
                </div>
                <div>
                    <h3 className="text-lg font-semibold text-gray-900">Inclination</h3>
                    <p className="text-sm text-gray-600">Vessel stability and tilt monitoring</p>
                </div>
            </div>
            <div className="flex flex-col w-full rounded gap-2 bg-white p-4">
                <div className="flex flex-row justify-evenly items-center gap-6">
                    <ShipStabilization dataSource={dataINC} />
                </div>
            </div>
        </div>
    )
}

export default Inclino